import axios from 'axios';
import { ChatGetAllQuery, ChatGetOneQuery, IdProps } from '../../types';

class ChatService {
  createMessage = ({ id, ...props }: any) => axios.post(`/chats/${id}/messages`, props);

  getAll = (props: any) => axios.get<ChatGetAllQuery>('/chats', props);

  get = ({ id }: IdProps) =>
    axios
      .get<ChatGetOneQuery>(`/chats/${id}`, { params: { notLoading: true } })
      .then((res) => res.data.data);
}

export const chatService = new ChatService();
